import styled from '@emotion/styled';

export default styled.div({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '2rem',
    gap: '0.5rem',
});
